export default __webpack_public_path__ + "static/media/browser2.89048b1c.png";